import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';

import { Input, Tooltip, Button } from '@salesforce/design-system-react';

import './TagSettings.scss';

export class TagSettings extends Component {
  constructor(props) {
    super(props);
    const settings =
      props.activation.unsavedSettings &&
      props.activation.unsavedSettings !== props.activation.settings
        ? props.activation.unsavedSettings
        : props.activation.settings;
    this.state = {
      maxTags: settings.maxTags,
      minConfidence: settings.minConfidence,
      prefix: settings.prefix,
      errors: {
        maxTags: false,
        minConfidence: false,
        prefix: false
      }
    };
  }

  setError(inputName, display) {
    this.setState(
      {
        errors: {
          ...this.state.errors,
          [inputName]: display
        }
      },
      () => {
        this.props.actions.updateInputErrors(inputName, display);
      }
    );
  }

  handleValidate(inputName, value) {
    if (inputName === 'maxTags') {
      if (Number(value) < 1 || Number(value) > 25 || isNaN(value)) {
        this.setError(inputName, true);
      } else {
        this.setError(inputName, false);
      }
    }

    if (inputName === 'minConfidence') {
      if (Number(value) < 0.5 || Number(value) > 1 || isNaN(value)) {
        this.setError(inputName, true);
      } else {
        this.setError(inputName, false);
      }
    }

    if (inputName === 'prefix') {
      if (value.length < 4) {
        this.setError(inputName, true);
      } else {
        this.setError(inputName, false);
      }
    }
  }

  handleInputChange(inputName, v) {
    this.handleValidate(inputName, v);
    this.setState({ [inputName]: v });
  }

  handleCancelSettings() {
    this.props.history.push({
      pathname: '/setup',
      search: this.props.location ? this.props.location.search : null
    });
  }

  handleSaveSettings() {
    this.props.actions.updateTagSettings(this.state);
    this.props.history.push({
      pathname: '/setup',
      search: this.props.location ? this.props.location.search : null
    });
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { status, version, useNestedTagApi } = this.props.activation;
    const changeDisabled = ['inactive', 'deleted'].indexOf(status) === -1;

    // Prefix input is hidden if activated with v2 or if status is null or deleted and useNestedTagApi is true
    const isStatusNullOrDeleted = status === 'deleted' || status === null;
    const isPrefixHidden =
      version === '2' || (isStatusNullOrDeleted && useNestedTagApi);

    return (
      <div className="tag-settings slds-col slds-size_1-of-1 slds-grid">
        <div className="tag-settings-input-wrap slds-grid slds-wrap slds-gutters">
          <div className="tag-settings-input slds-col slds-size_1-of-2">
            <Input
              label={formatMessage({ id: 'TagSettings.MaxTags.label' })}
              value={this.state.maxTags}
              onChange={(e, v) => this.handleInputChange('maxTags', v.value)}
              fieldLevelHelpTooltip={
                <Tooltip
                  align="top left"
                  content={formatMessage({ id: 'TagSettings.MaxTags.tooltip' })}
                />
              }
              errorText={
                this.state.errors.maxTags
                  ? formatMessage({ id: 'TagSettings.MaxTags.error' })
                  : null
              }
              disabled={changeDisabled}
            />
          </div>
          <div className="tag-settings-input slds-col slds-size_1-of-2">
            <Input
              label={formatMessage({ id: 'TagSettings.MinConfidence.label' })}
              value={this.state.minConfidence}
              onChange={(e, v) =>
                this.handleInputChange('minConfidence', v.value)
              }
              fieldLevelHelpTooltip={
                <Tooltip
                  align="top right"
                  content={formatMessage({
                    id: 'TagSettings.MinConfidence.advanced.tooltip'
                  })}
                />
              }
              errorText={
                this.state.errors.minConfidence
                  ? formatMessage({
                      id: 'TagSettings.MinConfidence.advanced.error'
                    })
                  : null
              }
              disabled={changeDisabled}
            />
          </div>
          {!isPrefixHidden && (
            <div className="tag-settings-input slds-col slds-size_1-of-2">
              <Input
                label={formatMessage({ id: 'TagSettings.TagPrefix.label' })}
                value={this.state.prefix}
                onChange={(e, v) => this.handleInputChange('prefix', v.value)}
                fieldLevelHelpTooltip={
                  <Tooltip
                    align="top left"
                    content={formatMessage({
                      id: 'TagSettings.TagPrefix.tooltip'
                    })}
                  />
                }
                errorText={
                  this.state.errors.prefix
                    ? formatMessage({
                        id: 'Settings.TagPrefix.error'
                      })
                    : null
                }
                disabled={changeDisabled}
              />
            </div>
          )}
        </div>
        <footer className="tag-settings-actions">
          <Button variant="neutral" onClick={() => this.handleCancelSettings()}>
            <FormattedMessage id="TagSettings.btn.cancel" />
          </Button>
          <Button
            variant="brand"
            onClick={() => this.handleSaveSettings()}
            disabled={
              Object.values(this.state.errors).indexOf(true) > -1 ||
              changeDisabled
                ? true
                : false
            }
          >
            <FormattedMessage id="TagSettings.btn.save" />
          </Button>
        </footer>
      </div>
    );
  }
}

TagSettings.propTypes = {
  activation: PropTypes.object,
  children: PropTypes.element,
  location: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(TagSettings);
